export const CN_DROPDOWN = [
  {
    dropd_id: 1,
    code: "CDNG01",
    value_th: "ลดราคาสินค้าที่ขาย (สินค้าผิดข้อกำหนดที่ตกลงกัน)",
    value_en: "",
    type: "creditnote",
  },
  {
    dropd_id: 2,
    code: "CDNG02",
    value_th: "สินค้าชำรุดเสียหาย",
    value_en: "",
    type: "creditnote",
  },
  {
    dropd_id: 3,
    code: "CDNG03",
    value_th: "สินค้าขาดจำนวน ตามที่ตกลงซื้อขาย",
    value_en: "",
    type: "creditnote",
  },
  {
    dropd_id: 4,
    code: "CDNG04",
    value_th: "คำนวณราคาสินค้าผิดพลาด สูงกว่าที่เป็นจริง",
    value_en: "",
    type: "creditnote",
  },
  {
    dropd_id: 5,
    code: "CDNG05",
    value_th: "รับคืนสินค้า (ไม่ตรงตามคำพรรณนา)",
    value_en: "",
    type: "creditnote",
  },
];

export const listPriority_CN = [
  {
    // RTS
    flag: "05c71457-7cfc-4a6f-8053-1e3653f03018",
  },
  {
    // POSHQ
    flag: "fb88a71f-fb1c-4c34-983e-d06bc927af32",
  },
];
